<template>
    <div class=chatbot-page :class="{ 'popup-active' : popupActive }">

        <div id="fb-root"></div>

        <!-- Your Chat Plugin code -->
        <div class="fb-customerchat"
                attribution=setup_tool
                page_id="100700305134383"
                greeting_dialog_display="show"
        ></div>

        <PageDescription :post="post" @open-popup="popupActive = true" @close-popup="popupActive = false" />

    </div>
</template>
<script>

import PageDescription from '../components/PageDescription.vue'

export default {
    name : 'ChatbotPage',
    props : {
        post : Object,
    },
    data() {
        return {
            popupActive : false,
        }
    },
    components : {
        PageDescription,
    },
    mounted() {

        window.fbAsyncInit = function() {
                window.FB.init({
                    xfbml            : true,
                    version          : 'v8.0',
                });
            };

        (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    },
    destroyed() {
        delete window.FB;
        document.querySelector('script[src="https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js"]').remove();
    }

}
</script>